export const sendGAEvent = (type: string, params: Record<string, string | number>) => {
  if (typeof window !== "undefined" && typeof gtag === "function") {
    gtag("event", type, {
      // event_category: "create_route",
      // event_label: "new_route",
      ...params,
    });
  }
}

export const trackGASubmitForm = (params: Record<string, string | number>) => {
  sendGAEvent('submit_form', params);
}

export const trackGAClick = (current: string, target: string) => {
  sendGAEvent('click', {
    page_location: current,
    link_url: target,
    outbound: false
  });
}
